/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAutoAwesomeIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-auto-awesome"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.13 6.28L16.13 5.35Q15.93 5.25 15.84 5.1Q15.75 4.95 15.75 4.75Q15.75 4.55 15.84 4.4Q15.93 4.25 16.13 4.15L18.13 3.23L19.02 1.27Q19.13 1.07 19.27 0.97Q19.43 0.88 19.63 0.88Q19.82 0.88 19.98 0.97Q20.13 1.07 20.23 1.27L21.13 3.23L23.13 4.15Q23.32 4.25 23.41 4.4Q23.5 4.55 23.5 4.75Q23.5 4.95 23.41 5.1Q23.32 5.25 23.13 5.35L21.13 6.28L20.23 8.25Q20.13 8.45 19.98 8.54Q19.82 8.63 19.63 8.63Q19.43 8.63 19.27 8.54Q19.13 8.45 19.02 8.25ZM6.3 15L1.7 12.9Q1.4 12.78 1.25 12.53Q1.1 12.28 1.1 12Q1.1 11.72 1.25 11.47Q1.4 11.22 1.7 11.1L6.3 9L8.43 4.38Q8.55 4.1 8.8 3.94Q9.05 3.77 9.32 3.77Q9.6 3.77 9.85 3.94Q10.1 4.1 10.22 4.38L12.35 9L16.95 11.1Q17.25 11.22 17.4 11.47Q17.55 11.72 17.55 12Q17.55 12.28 17.4 12.53Q17.25 12.78 16.95 12.9L12.35 15L10.22 19.63Q10.1 19.9 9.85 20.06Q9.6 20.23 9.32 20.23Q9.05 20.23 8.8 20.06Q8.55 19.9 8.43 19.63ZM18.25 20.9L16.25 19.98Q16.05 19.88 15.96 19.73Q15.88 19.57 15.88 19.38Q15.88 19.18 15.96 19.02Q16.05 18.88 16.25 18.77L18.25 17.85L19.15 15.88Q19.25 15.68 19.4 15.59Q19.55 15.5 19.75 15.5Q19.95 15.5 20.1 15.59Q20.25 15.68 20.35 15.88L21.25 17.85L23.25 18.77Q23.45 18.88 23.54 19.02Q23.63 19.18 23.63 19.38Q23.63 19.57 23.54 19.73Q23.45 19.88 23.25 19.98L21.25 20.9L20.35 22.88Q20.25 23.07 20.1 23.16Q19.95 23.25 19.75 23.25Q19.55 23.25 19.4 23.16Q19.25 23.07 19.15 22.88Z" fill={color} />
    </svg>
  );
}
